var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 75.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-2{fill:#ed3e49;}.cls-3{fill:#fdc826;}.cls-4{fill:#6dbc43;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coral") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coral"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.27,5.73c-14.75,1.8-29.91,9.48-37.41,22.74-8,14.07-12.68,34.86,5.66,43.08,17.89,8,45.57,4.48,60.22-8.81,4.77-4.37,6.72-5.9,9.81-11.83a61.48,61.48,0,0,0,5.26-14.19c1.37-6.21,1.43-12.4-1.29-18.27a17.61,17.61,0,0,0-7.71-8.11c-9.72-5.22-22.23-6.06-34.54-4.61m2.87,6.46c15.64-4.68,26,6.27,19.42,27.4-3.62,11.5-10.93,24.29-22.82,28.78-7.36,2.79-15.47,1.42-20.18-5.28-4.53-6.43-1.71-19.24.8-26C114.29,26.5,121.87,15.66,133.14,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194,8.73c1.75,1.91,1.67.86,3.48,2.82L176.2,73l19.17-.1,21.45-59.1c1.42-2.87,2.81-4.59,6.14-5.14,22-3.7,14.56,24.23-13.57,31.27l13,33,23,0-16.7-32.86c4.64-2.32,9.22-2.84,13.91-5.38,3.31-1.78,7.07-4.42,9.33-7.47,3.74-5,6.4-12.89.86-17.74-7.54-6.32-45.15-4.88-57.24-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.2,73.51l18.52-.15,16.51-21.85,24.86-.11L322,73.29l19.68.13-17-66c-4.21-4.67-16.85-2.89-20.14,1.5Zm38.3-28.59,15.53-22,5,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.2,56.92l-20.68-.09c-1.35,1.62-2,2.94-3.16,4.52-3.08,4-10.57,5.94-15.42,5.5-6.47-.66-10.07-5-11.1-11.2-1.44-9.29,3.1-26.89,9.7-33.73,3-3.09,7.9-6.65,12.08-7.8a19.36,19.36,0,0,1,9-.19c5.32,1,6.37,3.85,8.64,8.25l.18.35,19.28,0C81.22,15.48,70.09,8.74,64,6.86,40.45-.3,8.58,11.17,1.44,36.36-2.8,51.64,2.28,63.88,17,70.21c13.78,5.85,33.65,5.13,46.55-2.63,4.3-2.59,7.75-5.93,9.63-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367,8.5c4.23,3.19,5.24,3.86,3.06,11.09l-20.09,54,56.59-.14L410.31,61l-33.82,0,19.6-56.36-27.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M456.68,28.64c-7-8.46-20-1.94-25.45,3.68l3.06-9.95a51.46,51.46,0,0,0-13.09,7.51l-7,20.31c17-17.87,40.84.2,47.29-9.48-5.57-.27-10.06-4.22-12.77-8.89a27.27,27.27,0,0,1,8-3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M436.59,15.94l-2.3,6.43-3.06,10C455,17,453.63,37.05,473.58,26.64L480,8.52c-2.72,1.46-6.08,3.73-9.15,4.06s-7.59-.46-10.85-.66c-7.24-.44-16.11-.06-22.58,3.53l-.83.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M423.19,23.25c4-2.23,8.71-4.89,12.72-6.93,8.88-4.24,12.66-2.49,21.57-3.19,7-.56,11.29-4,16.16-8.72A18,18,0,0,0,477.19,0c-15.67,10.75-32.51-9.76-48.1,6.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoral);
export default __webpack_public_path__ + "static/media/coral.468157ec8e4d0ca88e838789381faab9.svg";
export { ForwardRef as ReactComponent };